import {match, Pattern} from 'ts-pattern';

import {isEmpty, isNil} from 'ramda';

import {MenuDynamicAccessKey, MenuItemProps} from '@dms/api/shared';

/**
 * Recursively drops menu items whose dynamic-access key resolves to false.
 * Items without a dynamic-access key are always kept, with one exception:
 * a parent whose children were all removed by the filter is hidden too,
 * so no empty menu section is ever rendered. This cascades upwards.
 */
export function filterMenuItemsByDynamicAccess(
  menuItems: MenuItemProps[],
  dynamicAccess: Record<MenuDynamicAccessKey, boolean>
): MenuItemProps[] {
  return menuItems
    .filter((menuItem) => isNil(menuItem.dynamicAccess) || dynamicAccess[menuItem.dynamicAccess])
    .flatMap((menuItem) =>
      match(menuItem.content)
        .with(Pattern.nullish, () => [menuItem])
        .when(isEmpty, () => [menuItem])
        .otherwise((content) => {
          const filteredContent = filterMenuItemsByDynamicAccess(content, dynamicAccess);

          return match(filteredContent)
            .when(isEmpty, () => [])
            .otherwise(() => [{...menuItem, content: filteredContent}]);
        })
    );
}
